import { render, staticRenderFns } from "./KundeDashboard.vue?vue&type=template&id=0e93d7b2&"
import script from "./KundeDashboard.vue?vue&type=script&lang=js&"
export * from "./KundeDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports